module.exports = __webpack_public_path__ + "img/img-mint-bg@2x.6ae3dbb9.png";